export default function getNumberOfReps(scenarioReps) {
	return Object.keys(scenarioReps).length;
}
